export default "__VITE_ASSET__CFryAOCB__"